import React from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/main.css';

export default function Footer({ businessName }) {
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const salePointName = pathSegments[1] || '';

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-left">
                    <span className="footer-brand">
                        &copy; {new Date().getFullYear()} {businessName || 'DinarSys'} • {salePointName || 'AliHameednew'}
                    </span>
                </div>
                <div className="footer-right">
                    <span className="footer-text">All rights reserved.</span>
                </div>
            </div>
        </footer>
    );
}
